if (!customElements.get('scent-picker')) {
  customElements.define(
    'scent-picker',
    class ScentPicker extends HTMLElement {
      connectedCallback() {
        this.nameEl = this.querySelector('.scent-picker__name');
        if (!this.nameEl) return;

        this.querySelectorAll('.scent-picker__link').forEach((link) => {
          link.addEventListener('mouseenter', () => this.show(link.dataset.scentName));
          link.addEventListener('focus', () => this.show(link.dataset.scentName));
          link.addEventListener('mouseleave', () => this.reset());
          link.addEventListener('blur', () => this.reset());
        });
      }

      show(name) {
        if (name) this.nameEl.textContent = name;
      }

      reset() {
        this.nameEl.textContent = this.nameEl.dataset.currentName;
      }
    }
  );
}
